import Component from 'inferno-component';
import { Sidebar, Segment, Menu, Image, Icon, Container } from 'semantic-ui-react'

export default class MobileNavigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false
    }

    this.onPusherClick = this.onPusherClick.bind(this);
    this.toggleVisibility = this.toggleVisibility.bind(this);
  }

  onPusherClick() {
    if(this.state.visible) {
      this.setState({visible: false});
    }
  };

  toggleVisibility() {
    this.setState({visible: !this.state.visible});
  };

  render() {

    return (
      <div>
        <Menu fluid floated borderless>
          <Menu.Item position='left' onClick={this.toggleVisibility}>
              <Icon name='sidebar' />
          </Menu.Item>
          <Menu.Item position='right'>
            <Image className='mr-1' src={'assets/images/logo/ua-logo.svg'} size='mini' />
            UnivAdvert
        </Menu.Item>
        </Menu>
        <Sidebar.Pushable as={Segment}>
          <Sidebar
            as={Menu}
            animation='overlay'
            width='thin'
            visible={this.state.visible}
            icon='labeled'
            vertical
            inverted
          >
            <Menu.Item name='marker' onClick={this.toggleVisibility} href="/#hirdetesi-helyszinek" >
              <Icon name='marker' />
              Hirdetési helyszínek
            </Menu.Item>
            <Menu.Item name='envelope' onClick={this.toggleVisibility} href="/#kapcsolat">
              <Icon name='envelope' />
              Kapcsolat
            </Menu.Item>
          </Sidebar>
          <Sidebar.Pusher

          >
            <Container fluid style={{marginLeft: '0 !important', marginRight: '0 !important;'}}>
              {this.props.children}
            </Container>
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/navigation/MobileNavigation.js